
import { defineComponent } from 'vue';
import { IDoctor } from '@/types/interfaces';

export default defineComponent({
  props: {
    selectedDoctor: { type: Number, default: null },
    doctor: { type: Object as () => IDoctor, required: true },
    select: { type: Boolean, default: true },
  },
  setup() {
    return {};
  },
});
